<template>
  <div class="banner-ct">
    <div class="paragraph-ct">
      <p class="top-paragraph">
        {{ $t('InfinityAI_Banner_Title') }}
      </p>
      <p class="bottom-paragraph">
        {{ $t('InfinityAI_Banner_Description') }}
      </p>
    </div>
    <div>
      <el-button @click="requestDemo()" type="primary">
        {{ $t('InfinityAI_Banner_Btn') }}
        <i class="el-icon-arrow-right el-icon-right" />
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MlStudioBookADemoBanner',
  methods: {
    requestDemo() {
      this.$emit('request-demo')
    }
  }
}
</script>

<style scoped>
.banner-ct {
  display: flex;
  color: white;
  justify-content: space-between;
  align-items: center;
  padding: 20px 65px;
  background: linear-gradient(94deg, #176ca1 -8.57%, #092e44 80.81%);
}

.paragraph-ct {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.top-paragraph {
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
}

.bottom-paragraph {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/modules/ml-studio/components/MlStudioBookADemoBanner.vue